/**
 * Le vol de la trousse, à la fin de l'écran d'ouverture : elle glisse de son grand plan vers le
 * coin droit, à la place EXACTE de la trousse de l'exercice, pour que l'élève la retrouve là où
 * elle se pose — au lieu de la voir disparaître d'un écran à l'autre.
 *
 * ⚠️ Miroir de `.jr-trousse` (`features/trousse/trousse.css`) : bord droit 4 px, centre à 23,607 %
 * de la hauteur, 44 × 89 px à l'échelle 1,2. Changer la place de la trousse = changer ces valeurs.
 */
export const TROUSSE_SPOT = {
  right: 4,
  top: 0.23607,
  width: 44,
  height: 89,
  scale: 1.2,
} as const;

export interface FlightBox {
  left: number;
  top: number;
  width: number;
  height: number;
}

export interface Flight {
  /** le déplacement, en pixels, du centre de la trousse */
  x: number;
  y: number;
  /** ce qu'il faut réduire pour tenir la place de la trousse de l'exercice */
  scale: number;
}

/**
 * De la boîte de la trousse en grand (le carré du canvas 3D) vers la DROITE DE L'ÉCRAN, à la hauteur
 * où l'exercice tient la sienne : elle sort du cadre, et la trousse de l'exercice entre par la droite
 * au même moment — c'est la même trousse qui se range. Elle occupe presque toute la hauteur de son
 * carré : l'échelle se mesure donc sur la hauteur de la trousse de l'exercice, pas sur sa largeur.
 */
export function trousseFlight(from: FlightBox, width: number, height: number): Flight {
  const size = TROUSSE_SPOT.height * TROUSSE_SPOT.scale;
  // au-delà du bord droit : la trousse réduite (de `size` de haut) a entièrement quitté l'écran
  const target = { x: width + size, y: height * TROUSSE_SPOT.top };
  return {
    x: Math.round(target.x - (from.left + from.width / 2)),
    y: Math.round(target.y - (from.top + from.height / 2)),
    scale: from.height > 0 ? Math.round((size / from.height) * 1000) / 1000 : 1,
  };
}
